import React, { useRef, useEffect } from "react";
import Anime from "react-anime";
import { useInView } from "react-intersection-observer";
import { animeSingleProps } from "@helpers/animations";
import { Heading } from "@components/Heading/Heading";
import { Container } from "@components/Container/Container";
import { AspectRatio } from "@components/AspectRatio/AspectRatio";
import { UmbracoBackgroundImage } from "@components/Image/UmbracoBackgroundImage/UmbracoBackgroundImage";
import { ImageField } from "@helpers/interfaces/image.js";

interface TunnelViewProps {
  Image: ImageField;
  Headline: string;
  Ratio: string;
}

async function initializeTunnelView(ref: HTMLElement) {
  const { default: TunnelViewInit } = await import("./TunnelView.init.js");
  new TunnelViewInit(ref);
}

const TunnelView: React.FC<TunnelViewProps> = ({ Image, Headline, Ratio }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const { ref, inView } = useInView({
    threshold: 0.2
  });
  const animateEachChild = {
    ...animeSingleProps,
    ...(inView ? { autoplay: true } : { autoplay: false })
  };

  useEffect(() => {
    if (containerRef.current) {
      initializeTunnelView(containerRef.current);
    }
  }, []);

  return (
    <div ref={containerRef} className="tunnel-view-ribbon">
      <section ref={ref}>
        <Container>
          <Anime {...animateEachChild}>
            <AspectRatio ratio={Ratio}>
              <UmbracoBackgroundImage
                image={Image}
                width={[375, 700, 1350, 1350]}
              >
                <div className="tunnel-view">
                  <canvas className="tunnel-canvas"></canvas>
                  <div className="tunnel-action">
                    <button data-radius="0.47" className="selected">
                      0,0&permil;
                    </button>
                    <button data-radius="0.352">0,8&permil;</button>
                    <button data-radius="0.23">1,2&permil;</button>
                    <button data-radius="0.15">2,0&permil;</button>
                  </div>
                </div>
              </UmbracoBackgroundImage>
            </AspectRatio>
            <div className="tunnel-teaser">
              <Heading as="h2">{Headline}</Heading>
            </div>
          </Anime>
        </Container>
      </section>
    </div>
  );
};

export { TunnelView };
